export const commandType = "SCHEDULE_SET_XY_SPEED";
export const label = "Set speed";
export const isAdminOnly = true;
export const isAdvanced = false;
export const organizations = [];
